import { useState, useCallback } from 'react';
import axios from 'axios';
import env from '../utils/env.config';

interface PostParams {
  path: string;
  payload?: object | any;
  headers?: object;
}

interface Response {
  message: string;
  data: any | null;
  error: null;
  isLoading: boolean;
}

export default function usePost({ path, payload = null, headers }: PostParams) {
  const [response, setResponse] = useState<Response>({
    message: '',
    data: null,
    error: null,
    isLoading: false,
  });

  const apiCall = useCallback(
    (params?: {}) => {
      let isSubscriber = true;
      const form = new FormData();
      if (payload) {
        for (const [key, value] of Object.entries({ ...payload, ...params })) {
          form.append(key, value as any);
        }
      }

      if (isSubscriber) {
        setResponse((prevState) => ({ ...prevState, isLoading: true }));
      }

      axios
        .post(`${env.SERVER_URL}/${path}.php`, form, headers)
        .then((res) => {

          if (isSubscriber) {
            setResponse({
              message: res.data.message,
              data: res.data.data,
              isLoading: false,
              error: res.data.error,
            });
          }
        })
        .catch((error) => {
          console.log('POST-ERROR', error);
          if (isSubscriber) {
            setResponse({ message: '', data: null, isLoading: false, error });
          }
        });
      return () => {
        isSubscriber = false;
      };
    },
    [path, headers, payload]
  );

  return [response, apiCall] as const;
}
